import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function PrivacyPolicy() {
  return (
    <div>
        <Topheader colorbox="newfaq_header_color" title="Privacy Policy" />
                     <div className="main-container mb-5 px-3">
                        <div className={style.sub_text1}>
                            We Keep an eye on th game, not you!
                        </div>
                         <div className={style.sub_text3}>
                            Links to the following sections of these Terms are provided below for easy access to the sections you intend to refer to. However, you should read all Terms as you will be bound by them all upon any use of any section of this Website.
                         </div>
                         <div className={style.sub_text2}>
                            Information Gathered
                         </div>
                         <div className={style.sub_text3}>
                            Links to the following sections of these Terms are provided below for easy access to the sections you intend to refer to. However, you should read all Terms as you will be bound by them all upon any use of any section of this Website.
                         </div>
                         <ul>
                    <li className={style.sub_text3}>Applicable Law(s)” means all applicable statutes, enactments, laws, ordinances, treaties, conventions, protocols, bye-laws, rules, regulations, guidelines, notifications, notices, and/ or judgments, decrees, injunctions, writs or orders, instructions, decisions of any court or and awards or other requirements or official directives of any governmental authority, in any jurisdiction, as may be applicable to the relevant person.</li>
                    <li className={style.sub_text3}>“Bank Account” means a financial account maintained with a Banking Company or a financial institution and shall include a wallet maintained with an entity authorized by Reserve Bank of India.</li>
                   </ul>

                     </div>
    </div>
  )
}
